import axios from "axios";
import config from "../config";

/**
 * Dedicated client for the public course-landing (sales page) data.
 *
 * This endpoint lives on the membership admin app (fleximembership), NOT the
 * Lumen community bridge, and is public (no auth). We use a standalone axios
 * instance so the global session-expiry interceptor (axiosSetup) never touches
 * these requests.
 */
const client = axios.create({ baseURL: config.LANDING_API_URL });

/**
 * Fetch the landing payload for a Course Area public code.
 * Returns the assembled object (template_id, theme colours, content blocks,
 * curriculum, instructor, …) or throws (404 when the code doesn't resolve).
 */
export async function fetchCourseLanding(code) {
  const res = await client.get(`/cs/${encodeURIComponent(code)}`);
  return res.data;
}
